import { useTranslation } from "react-i18next";
//Components
import { ActionsManagementContainer, ManagementDiv, SaveAndCancelDiv, SaveButton, CancelButton } from "./styles";
import ButtonWithIcon from "../../../../buttonWithIcon";
// Assets
import EditUserImg from "../../../../../assets/icons/btn_edit_user.svg";

const ActionsManagement = ({ handleSubmit, isDisabledInputs, setIsDisabledInputs, setInitialState }) => {
  const [t] = useTranslation("global");

  return (
    <ActionsManagementContainer>
      {isDisabledInputs ? (
        <ManagementDiv justifyContent="flex-start">
          <ButtonWithIcon onClick={() => setIsDisabledInputs(false)} icon={EditUserImg} name={t("questionnaires_managementActions_edit")} />
        </ManagementDiv>
      ) : (
        <ManagementDiv justifyContent="space-between">
          <SaveAndCancelDiv>
            <SaveButton onClick={handleSubmit}>{t("save")}</SaveButton>
            <CancelButton onClick={setInitialState}>{t("discard_changes")}</CancelButton>
          </SaveAndCancelDiv>
        </ManagementDiv>
      )}
    </ActionsManagementContainer>
  );
};

export default ActionsManagement;
